import { render, staticRenderFns } from "./order-create-header.vue?vue&type=template&id=16d3ceb0&"
import script from "./order-create-header.ts?vue&type=script&lang=ts&"
export * from "./order-create-header.ts?vue&type=script&lang=ts&"
import style0 from "./order-create-header.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports